import MasterCrud from "@/components/MasterCrud";
import { Briefcase } from "lucide-react";

export default function HRMSDesignations() {
  return (
    <MasterCrud
      endpoint="/designations"
      slug="hr-desig"
      title="Designation Master"
      subtitle="HRMS · Designations"
      icon={Briefcase}
      importKey="designations"
      fields={[
        ["name", "Name"],
        ["department", "Department", "select", "/departments"],
        ["status", "Status", "select-static", ["Active", "Inactive"]],
      ]}
    />
  );
}
